import React, { useEffect, useState, useRef } from 'react'
import CategoryCard from '../components/molecules/category-card/category-card'
import FavoriteSection from '../components/molecules/favorite-section/favorite-section'
import { useAuth } from '../customHooks/useAuth'
import { ALLOWED_APPS } from '../constants/routes'
import axios from '../utils/axios'
import type { AxiosResponse } from 'axios'
import { useNavigate } from 'react-router-dom'

const APP_LIST_API = process.env.REACT_APP_APPLIST_API as string

export type AppList = {
  data: {
    categorySysId: string
    name: string
    description: string
    apps: [
      {
        name: string
        description: string
        appSysId: string
        landingPageUrl: string
        categorySysId: string
        signedUrlForLogo: string
      },
    ]
  }[]
}

export const OverView = () => {
  const { user } = useAuth()
  const [appList, setAppList] = useState<AppList | null>(null)
  const [allowedAppList, setAllowedAppList] = useState<string[] | undefined>()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const navigate = useNavigate()
  const effectRan = useRef(false)

  useEffect(() => {
    if (!user?.authenticated) {
      navigate('/sign-in', { replace: true })
    }
  }, [user?.authenticated])

  useEffect(() => {
    if (effectRan.current) return
    getAppLists()
    getAllowedAppLists()
    effectRan.current = true
  }, [])

  const getAppLists = async () => {
    setIsLoading(true)
    const config = {
      method: 'GET',
      url: APP_LIST_API,
      headers: {
        'x-user': user?.email,
        'x-access-token': user?.tokens?.accessToken?.token,
        'x-source': user?.isSSO ? 'sso' : null,
      },
    }
    const response: AxiosResponse<AppList> = await axios.request<AppList>(config)
    setAppList(response.data)
    setIsLoading(false)
  }

  const getAllowedAppLists = async () => {
    setIsLoading(true)
    const config = {
      method: 'GET',
      url: ALLOWED_APPS,
      headers: {
        'x-user': user?.email,
        'x-access-token': user?.tokens?.accessToken?.token,
        'x-source': user?.isSSO ? 'sso' : null,
      },
    }
    const response: AxiosResponse = await axios.request(config)
    setAllowedAppList(response?.data?.data?.authorisedApp)
    setIsLoading(false)
  }
  return (
    <div className="dashboard">
      <div className="dashboard-inner-container">
        <FavoriteSection appList={appList} isLoading={isLoading} />
        <CategoryCard appList={appList} allowedApps={allowedAppList} isLoading={isLoading} />
      </div>
    </div>
  )
}

export default OverView
